module.exports = __webpack_public_path__ + "img/send.857deeeb.png";